import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AuthGuard } from "src/auth/guard";
import { LoadingScreen } from "src/components/loading-screen";
import CompactLayout from "src/layouts/compact";
import DefaultLayout from "src/layouts/default";
import { paths } from "src/routes/paths";

// ----------------------------------------------------------------------

const MyAccountView = lazy(() => import("src/sections/my-account/detail/view"));
const ChangePasswordView = lazy(
  () => import("src/sections/my-account/change-password/view")
);
const ChangePasswordCompletePage = lazy(
  () => import("src/pages/auth/complete-change-password")
);

// ----------------------------------------------------------------------

export const myAccountRoutes = [
  {
    element: (
      <AuthGuard>
        <DefaultLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DefaultLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: paths.myAccount.root,
        element: <MyAccountView />,
      },
      {
        path: paths.myAccount.changePassword.root,
        element: <ChangePasswordView />,
      },
    ],
  },
  {
    element: (
      <AuthGuard>
        <CompactLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </CompactLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: paths.myAccount.changePassword.complete,
        element: <ChangePasswordCompletePage />,
      },
    ],
  },
];
